import React, { useState, useEffect } from "react";
import "./About.css";
import { Link } from "react-router-dom";
import Loader from "./Loader.jsx";
import { FaArrowRight, FaPlus, FaMinus, FaTimes } from "react-icons/fa";

const About = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [activeSection, setActiveSection] = useState("objectives");
  const [isScrolled, setIsScrolled] = useState(false);

  const objectives = [
    {
      title: "நாட்டுப்பற்று மற்றும் சமூக உணர்வு",
      description:
        "மாணவர்கள், இளைஞர்கள், பெண்கள் மற்றும் பொது மக்கள் மத்தியில் நாட்டுப்பற்று மொழிப்பற்று மற்றும் சமூக உணர்வு ஏற்படப் பாடுபடுதல்"
    },
    {
      title: "இளைஞர்களின் வளர்ச்சி",
      description:
        "இளைஞர்களைத் தன்னம்பிக்கைமிக்கவர்களாகவும், இடைவிடாது உழைத்து முன்னேறி அவரவர் துறையில் மிகச் சிறந்து விளங்கக் கூடியவர்களாகவும், தன்னலமற்ற தியாக உள்ளமும் சேவையுணர்வும் கொண்டவர்களாகவும் உருவாக்கப் பாடுபடுதல்"
    },
    {
      title: "பாரம்பரியம் மற்றும் பண்பாடு",
      description:
        "நம் நாட்டின் பாரம்பரியம், பண்பாடு, கலாச்சாரம், கலை, இலக்கியம், வரலாறு, குறிப்பாக விடுதலைப் போராட்ட வரலாறு முதலியவற்றை இளைய தலைமுறை முழுமையாக அறிந்து கொள்ளப் பாடுபடுதல்"
    },
    {
      title: "வரலாறு மற்றும் தேசபக்தி",
      description:
        "'கடந்தகால இந்தியாவைப் படிப்போம், எதிர்கால இந்தியாவைப் படைப்போம்' என்ற கோணத்தில் வரலாற்றை மக்களிடத்தில் கொண்டு செல்வதோடு, 'இன்றைய தேசபக்தி எது?' என்பதை அவர்களுக்குத் தெளிவுபடுத்தப் பாடுபடுதல்"
    },
    {
      title: "சமூக விழிப்புணர்வு",
      description:
        "மக்கள் மத்தியில் விழிப்புணர்வைக் கொண்டுவந்து, நாட்டில் தலைவிரித்தாடும் லஞ்சம், ஊழல், கலப்படம், மோசடி முதலிய சமூகவிரோதச் செயல்களைத் தடுத்து நிறுத்துப் பாடுபடுதல்"
    }
  ];

  const studentObjectives = [
    {
      id: 1,
      description:
        "பாடப் புத்தகங்களை நன்றாகப் படிப்பதோடு அறிவை விரிவுசெய்யும் விதத்தில் பிற நல்ல பொதுவான புத்தகங்களை வாசிக்க வழிவகை செய்வது"
    },
    {
      id: 2,
      description:
        "மதிப்பெண்கள் பெறுவதோடு வாழ்வின் மதிப்புகளைக் (Human Values) கற்றுக் கொள்வதற்கான சூழலை உருவாக்குவது"
    },
    {
      id: 3,
      description: "பொது அறிவை வளர்க்க இன்னும் பலவழிகளில் முயற்சிப்பது"
    },
    {
      id: 4,
      description:
        "மாணவர்களின் தனித்திறன்களைக் கண்டறிந்து அவற்றை வளர்ப்பதற்குரிய பயிற்சியும் வாய்ப்பும் அளிப்பது"
    },
    {
      id: 5,
      description: "மாணவர்களை ஆளுமைமிக்கவர்களாக வளர்த்தெடுக்க முயற்சிப்பது"
    },
    {
      id: 6,
      description:
        "மாணவர்களிடையே சமுதாய உணர்வையும் சிந்தனையையும், செயற்பாட்டையும் வளர்ப்பது"
    },
    {
      id: 7,
      description:
        "வாழ்வியல் கோட்பாடுகளை அறிந்து வைத்திருப்பதோடு, பண்பாடுமிக்க நல்ல குடிமகனாக வளர்வதற்கான அடித்தளமிடுவது"
    },
    {
      id: 8,
      description:
        "தாய் - தந்தையரையும், தாய்நாட்டையும், தாய்மொழியையும் மதிக்கும் நற்சிந்தனைகளை மாணவர்களிடையே விதைப்பது"
    },
    {
      id: 9,
      description:
        "சமூக அமைதி குறித்தும், நல்லிணக்கம் பற்றியும், சகோதரத்துவம் பற்றியுமான முறையான புரிதலை மாணவர்களுக்கு ஏற்படுத்துவது"
    },
    {
      id: 10,
      description:
        "தான் தனிப்பட்ட முறையில் சிறப்பாக வளர்வதோடு இச்சமூகத்தையும் அம்முறையில் வளர்ப்பது கடமை என்று உணர்ந்து செயல்பட வைப்பது"
    },
    {
      id: 11,
      description:
        "லஞ்சம், ஊழல் போன்ற சமூக அவலங்களுக்கு எதிரான கண்ணோட்டத்தைத் தொடக்கத்திலிருந்தே பல முறைகளில் முயன்று உருவாக்குவது"
    },
    {
      id: 12,
      description:
        "மது, பிற போதைப் பொருட்களின் தீயவிளைவுகள் மற்றும் புகைபிடித்தல் போன்ற தீங்கினை அறிவியல் பூர்வமாகவும், உளவியல் ரீதியாகவும், வாழ்வியல் மூலமாகவும் உணரச் செய்து அவற்றிலிருந்தும் மற்ற தீய பழக்க வழக்கங்களிலிருந்தும் முற்றிலும் விலகி நிற்பவர்களாக மாணவப் பருவத்திலிருந்தே வளர்ந்திட வித்தியாசமான முயற்சிகளை மேற்கொள்வது"
    },
    {
      id: 13,
      description:
        "மாணவர்களிடையே ஆக்கபூர்வமான சிந்தனைகளை வளர்ப்பதோடு புதிய அறிவியல் கண்டுபிடிப்புகள் குறித்த கண்ணோட்டத்தை உருவாக்கி வாய்ப்பும் சூழலும் இருப்போரை இதற்காகக் களமிறங்கத் தூண்டுவது"
    },
    {
      id: 14,
      description:
        "மாணவர்களிடையே உடல் ஆரோக்கியம் குறித்த விழிப்புணர்வை ஏற்படுத்துவது விளையாட்டு, உடற்பயிற்சி, யோகா போன்றவற்றில் ஈடுபாட்டை உருவாக்குவது"
    }
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/about.json");
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        setSections(data.sections);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const zoomIn = (e) => {
    e.stopPropagation();
    setZoomLevel((prev) => Math.min(prev + 0.25, 3));
  };

  const zoomOut = (e) => {
    e.stopPropagation();
    setZoomLevel((prev) => Math.max(prev - 0.25, 1));
  };

  const openImage = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = "hidden";
  };

  const closeImage = () => {
    setSelectedImage(null);
    document.body.style.overflow = "auto";
    setZoomLevel(1);
  };

  const pad = (n) => String(n).padStart(2, "0");

  if (loading) return <Loader />;
  if (error) return <div className="error-message">Error: {error}</div>;

  return (
    <div className="about-container">
      {/* Section index / navigation rail */}
      <div className={`section-navigation ${isScrolled ? "scrolled" : ""}`}>
        <button
          className={`nav-bubble ${
            activeSection === "objectives" ? "active" : ""
          }`}
          onClick={() => {
            setActiveSection("objectives");
            document
              .getElementById("objectives")
              ?.scrollIntoView({ behavior: "smooth" });
          }}
          data-tooltip="அமைப்பின் நோக்கங்கள்"
        >
          <span>01</span>
        </button>
        <button
          className={`nav-bubble ${
            activeSection === "student-objectives" ? "active" : ""
          }`}
          onClick={() => {
            setActiveSection("student-objectives");
            document
              .getElementById("student-objectives")
              ?.scrollIntoView({ behavior: "smooth" });
          }}
          data-tooltip="மாணவர்களுக்கான பணிகள்"
        >
          <span>02</span>
        </button>
        <button
          className={`nav-bubble ${
            activeSection === "gallery" ? "active" : ""
          }`}
          onClick={() => {
            setActiveSection("gallery");
            document
              .getElementById("gallery")
              ?.scrollIntoView({ behavior: "smooth" });
          }}
          data-tooltip="புகைப்பட தொகுப்பு"
        >
          <span>03</span>
        </button>
      </div>

      {/* Objectives Section */}
      <section id="objectives" className="section objectives-section">
        <div className="section-header">
          <span className="section-eyebrow">01 &mdash; இலட்சியங்கள்</span>
          <h2>அமைப்பின் நோக்கங்கள்</h2>
          <p className="section-subtitle">
            நாங்கள் நம்பும் இலட்சியங்கள் மற்றும் நோக்கங்கள்
          </p>
        </div>

        <div className="postbtnmain">
          <a className="postbtn" href="/post">
            முந்தைய பதிவுகள் <FaArrowRight />
          </a>
        </div>

        <div className="objectives-list">
          {objectives.map((objective, index) => (
            <div key={index} className="objective-row">
              <span className="objective-number">{pad(index + 1)}</span>
              <div className="objective-content">
                <h3>{objective.title}</h3>
                <p>{objective.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="join-us-card">
          <h3>எங்களுடன் இணைவது எப்படி?</h3>
          <p>
            இந்த அமைப்பின் அடிப்படைநோக்கங்களையும் இலட்சியங்களையும்
            ஏற்றுக்கொள்பவர்கள் இவ்வமைப்பில் உறுப்பினராகப் பதிவு செய்து
            கொள்ளலாம்.
          </p>
          <Link to="/contact" className="join-button">
            உறுப்பினராக சேருங்கள் <FaArrowRight className="button-icon" />
          </Link>
        </div>
      </section>

      {/* Student Objectives Section */}
      <section id="student-objectives" className="section student-section">
        <div className="section-header">
          <span className="section-eyebrow">02 &mdash; மாணவர் பணி</span>
          <h2>மாணவர்களுக்கான பணிகள்</h2>
          <p className="section-subtitle">
            மாணவர்களிடையே மக்கள் சிந்தனைப் பேரவையின் பணிகள் - முயற்சிகள்
          </p>
        </div>

        <div className="student-objectives-list">
          {studentObjectives.map((objective) => (
            <div key={objective.id} className="student-row">
              <span className="student-number">{pad(objective.id)}</span>
              <p>{objective.description}</p>
            </div>
          ))}
        </div>

        <div className="conclusion-box">
          <p>
            இன்னும் இதுபோன்ற மாணவர் நலன் சார்ந்த பல்வேறு முயற்சிகளிலும்
            பணிகளிலும் ஈடுபட்டு வருகிறது 'மக்கள் சிந்தனைப் பேரவை'
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="section gallery-section">
        <div className="section-header">
          <span className="section-eyebrow">03 &mdash; தொகுப்பு</span>
          <h2>புகைப்பட தொகுப்பு</h2>
          <p className="section-subtitle">
            எங்கள் செயல்பாடுகள் மற்றும் நிகழ்வுகள்
          </p>
        </div>

        <div className="gallery-grid">
          {sections.map((section, index) => (
            <div key={index} className="gallery-group">
              <h3 className="gallery-group-title">{section.title}</h3>
              <div className="gallery-images">
                {section.images.map((image, imgIndex) => (
                  <div
                    key={imgIndex}
                    className="gallery-item"
                    onClick={() => openImage(image)}
                  >
                    <img
                      src={`/images/${image}`}
                      alt={`${section.title} ${imgIndex + 1}`}
                      loading="lazy"
                    />
                    <div className="gallery-overlay">
                      <span>View</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImage}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={`/images/${selectedImage}`}
              alt="Fullscreen"
              style={{ transform: `scale(${zoomLevel})` }}
            />
            <button className="close-modal" onClick={closeImage}>
              <FaTimes />
            </button>
            <div className="zoom-controls">
              <button onClick={zoomIn}>
                <FaPlus />
              </button>
              <button onClick={zoomOut}>
                <FaMinus />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default About;